export default {
  selectedTrips: function() {
    return this.trips.filter(trip => typeof trip?.trip === 'string' && trip.trip)
  },

  selectedIds: function() {
    return this.selectedTrips.map(item => item.trip && item.trip.replace(/[^0-9]/g, ''))
  },

  canCheckout: function() {
    if (!this.product) {
      return false
    }

    if (this.product.hasTrip) {
      return !this.trips.filter(trip => (trip?.trip === '' || trip?.duration < 7)).length
    }

    return this.boost.quantity > 0
  },

  totalAmount: function() {
    if (!this.product) {
      return 0
    }

    if (this.installments && this.availableInstallments.length) {
      return this.availableInstallments[this.installments - 1].total
    }

    if (this.product.hasTrip) {
      return this.trips.reduce((total, trip) => total + (trip?.trip && Math.ceil(trip?.duration * this.product.price) || 0), 0);
    }

    return Math.ceil(this.boost.quantity * this.product.price)
  },
}
